import { Props as SelectProps } from "react-select";
import { Option } from "@/@types/generics/Option";
import { SelectComponent } from "../SelectComponent";

type Props = SelectProps & {
	label?: string;
	options?: Option<boolean | undefined>[];
};

export const accompanimentCitizenTypeIndicatorEsbOptions: Option<boolean | undefined>[] = [
	{ value: true, label: "Cidadãos atendidos" },
	{ value: undefined, label: "Cidadãos vinculados" },
];

export const accompanimentCitizenTypeIndicatorC2Options: Option<boolean | undefined>[] = [
	{ value: undefined, label: "Crianças com até 2 anos" },
	{ value: true, label: "Crianças com 2 anos completos" },
];

export const accompanimentCitizenTypeIndicatorC3Options: Option<boolean | undefined>[] = [
	{ value: undefined, label: "Gestantes e puérperas" },
	{ value: true, label: "Puérperas" },
];

export const accompanimentCitizenTypeOptions: Option<boolean | undefined>[] = [
	{ value: undefined, label: "Cidadão monitorado" },
	{ value: true, label: "Cidadão avaliado" },
];

export function AccompanimentCitizenTypeSelect({ label, options, ...rest }: Props) {
	return (
		<div className="d-flex flex-column">
			<label htmlFor={rest.id} className="form-label text-start">
				{label ?? "Tipo de identificação:"}
			</label>
			<SelectComponent
				id={rest.id}
				className="text-start"
				placeholder="Selecione..."
				noOptionsMessage={() => "Nenhum nenhum indicador encontrado"}
				options={options ?? accompanimentCitizenTypeOptions}
				{...rest}
			/>
		</div>
	);
}
